import { PresentationPrivacyType } from "common/constants";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { t } from "js/i18n";

export const LinkType = {
    PUBLIC: "public",
    PROTECTED: "protected",
    INVITE: "invite",
    EMBED: "embed",
    SOCIAL: "social",
    MEETING: "meeting",
    INTEGRATOR: "integrator",
};

const translate = key => t(key);

export default class linkDS {
    static createPublicLink(presentation, name) {
        return presentation.links.createLink({
            name: name ?? translate("Public Link"),
            type: LinkType.PUBLIC
        });
    }

    static createProtectedLink(presentation, name) {
        return presentation.links.createLink({
            name: name ?? translate("Protected Link"),
            type: LinkType.PROTECTED,
        });
    }

    static createEmbedLink(presentation) {
        const secured = presentation.getPrivacySetting() === PresentationPrivacyType.SECURED;

        return presentation.links.createLink({
            name: secured ? translate("Secured Embed Link") : translate("Embed Link"),
            type: LinkType.EMBED
        });
    }

    static createIntegratorLink(presentation) {
        return presentation.links.createLink({
            name: `integration-${app.integrator.type}`,
            type: LinkType.INTEGRATOR
        });
    }

    static createInviteLink(presentation, email, customMessage, expiresAt, allowCommenting) {
        return presentation.links.createLink({
            name: translate("Invite"),
            email,
            customMessage,
            expiresAt,
            allowCommenting,
            type: LinkType.INVITE
        });
    }

    static createSocialLink(presentation, socialNetwork, allowCommenting) {
        return presentation.links.createLink({
            name: socialNetwork,
            type: LinkType.SOCIAL,
            allowCommenting,
        });
    }

    static createMeetingLink(presentation) {
        let meetingId = new Date().getTime().toString().substr(4);
        let hostPIN = Math.round(Math.random() * 899) + 100;
        // TODO: check if meeting id conflicts

        return presentation.links.createLink({
            name: translate("My meeting"),
            type: LinkType.MEETING,
            meetingId,
            hostPIN,
            hasAudio: false
        });
    }

    static updateLink(link, options) {
        if ("password" in options) {
            link.updatePassword(options.password);
        }

        if ("domainWhitelist" in options) {
            link.connectEmbedDomains(options.domainWhitelist);
        }

        delete options.password;
        return link.update(options);
    }

    static saveLink(presentation, link) {
        return presentation.links.addLink(link);
    }

    static deleteLink(presentation, id) {
        return presentation.links.deleteLink(id);
    }

    static getLinkById(presentation, id) {
        return presentation.links.get(id);
    }

    static getPresentation() {
        return ds.selection.presentation;
    }
}

/**
 * Validates password requirements for a presentation link
 * (currently, we just require non-empty password)
 */
export function validateLinkPassword(password) {
    if (!password) {
        return translate("Password is required");
    }
}
